
import { Vue, Component } from 'vue-property-decorator'
import { ENVIRONMENT } from '@/commons/configuration'
import { FALLBACK_LOCALE } from '@/commons/constants/locale'

@Component({})
export default class AccessibilityNotice extends Vue {
    created (): void {
        document.title = this.$tc('metadata.accessibilityNotice')
    }

    get etkAddressUrl (): string {
        return ENVIRONMENT.etkAddressUrl[this.$i18n.locale] || ENVIRONMENT.etkAddressUrl[FALLBACK_LOCALE]
    }

    get youtubeAddressUrl (): string {
        return ENVIRONMENT.makePhotosVideoAddressUrl[this.$i18n.locale] || ENVIRONMENT.makePhotosVideoAddressUrl[FALLBACK_LOCALE]
    }

    get accessibilityManualUrl (): string {
        return ENVIRONMENT.accessibilityManualUrl[this.$i18n.locale] || ENVIRONMENT.accessibilityManualUrl[FALLBACK_LOCALE]
    }
}
